import React from 'react';
import { HowScoringWorks, HowScoringWorksMobile } from 'src/assets/images';

const ScoringProcess: React.FC = () => {
  return (
    <section className="scoring-process-section">
      <h2>How scoring works?</h2>
      <div className="process-steps">
        <img src={HowScoringWorks} alt="How Scoring Works" className='processIllustration' />
        <img src={HowScoringWorksMobile} alt="How Scoring Works" className='processIllustration2' />
      </div>
    </section>
  );
};

export default ScoringProcess;
